import { useFela } from 'react-fela';
import { useFormState } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/modules/ui';

import { DelimiterField } from '../DelimiterField';
import { ReplaceSecretsField } from '../ReplaceSecretsField';
import { SecretsField } from '../SecretsField';
import { SecretsFormatField } from '../SecretsFormatField';
import * as felaRules from './ImportFormFields.rules';

export interface ImportFormFieldsProps {
    withReplaceSecrets: boolean;
}

export const ImportFormFields = ({ withReplaceSecrets }: ImportFormFieldsProps) => {
    const { css } = useFela();

    const { isSubmitting } = useFormState();

    return (
        <>
            <SecretsField />
            <div className={css(felaRules.optionsWrapper)}>
                <SecretsFormatField />
                <DelimiterField />
            </div>
            <div className={css(felaRules.buttonWrapper)}>
                {withReplaceSecrets && <ReplaceSecretsField />}
                <Button type='primary' htmlType='submit' loading={isSubmitting} disabled={isSubmitting}>
                    <FormattedMessage id='import.form.button' />
                </Button>
            </div>
        </>
    );
};
